import React from 'react';
import { Text, View, Pressable, StyleSheet } from 'react-native';

import { COLOR, THEME } from '../../../../constants/styles';

import RemoveButton from '../remove_button';

export function ImageRemove(props) {
  handleRemove = () => {
    props.onRemove(props.attachment);
  };

  return (
    <View style={[styles.container, props.containerStyle]}>
      <View style={styles.imageContainer}>{props.children}</View>

      {!props.hideRemoveButton && (
        <View style={styles.button}>
          <RemoveButton onPress={this.handleRemove} />
        </View>
      )}
    </View>
  );
}

export function LinkRemove(props) {
  handleRemove = () => {
    props.onRemove(props.attachment);
  };
  handlePress = () => {
    props.onPress(props.attachment);
  };

  return (
    <View style={[{ flexDirection: 'row', alignItems: 'center' }, props.containerStyle]}>
      <Pressable onPress={handlePress}>
        <Text style={[THEME.linkStyle, { textDecorationLine: 'underline' }]}>
          {props.attachment?.fileName}
        </Text>
      </Pressable>

      {!!props.onRemove && (
        <View style={{ marginLeft: 10 }}>
          <RemoveButton onPress={this.handleRemove} />
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    paddingTop: 10,
    paddingRight: 10,
    // backgroundColor: 'yellow'
  },
  imageContainer: {
    borderRadius: 8,
    overflow: 'hidden',
  },
  button: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
});
